/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

const customizationSlice = createSlice({
  name: 'customization',
  initialState: {} as any,
  reducers: {
    setCustomization: (
      state,
      {
        payload: { customization },
      }: PayloadAction<{ customization: any }>,
    ) => {
      state = customization
    },
  },

  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      state = customizationSlice.getInitialState().customization
    })
  },
})

export const { setCustomization } = customizationSlice.actions

export default customizationSlice.reducer
